export default __webpack_public_path__ + "static/media/16418216956.7014e1d1.JPG";